// Shows an API error to the executive. Split from apiErrors.js so pure
// helpers (and their tests) don't load localization.
import { t } from "@constants/localization";
import { notifyError } from "./notify";
import { extractErrorCode, shouldShowLocalError } from "./apiErrors";

/**
 * Toasts the local string for an API error (unless the interceptor already
 * showed the server's message) and returns the error code, so the caller can
 * branch on it. Call with no error for an empty response: that shows the
 * generic string.
 * @param {*} error an axios error, or undefined
 * @param {(code: string|null) => string} messageKeyOf code → i18n key
 */
export function showApiError(error, messageKeyOf) {
  const code = extractErrorCode(error);
  if (shouldShowLocalError(error)) notifyError(t(messageKeyOf(code)), "");
  return code;
}
